export default {
    "van": {
        "name": "名稱",
        "confirm": "確認",
        "cancel": "取消"
    },
    "app": {
        "confirm": "確定",
        "cancel": "取消",
        "skip": "跳過",
        "request": {
            "error_info": "錯誤信息",
            "copy": "複製"
        },
        "message": {
            "hello": "你好,世界"
        },
        "home": {
            "search_area": "經銷商地區",
            "search_area_content": "經銷商地址",
            "gotothis": "到這去",
            "area_select": "選擇地址",
            "selfplace": "當前位置",
            "dealerfullname": "經銷商名稱",
            "dealeraddress": "經銷商地址",
            "map_store_query_title": "門店查詢",
            "map_store_location_fallback_hint": "(當前定位權限未允許,使用默認地址)",
            "map_store_select_province": "選擇省份",
            "map_store_search_province_placeholder": "搜索省份",
            "map_store_search_store_placeholder": "搜索門店名稱",
            "map_store_search_store_or_code_placeholder": "搜索省份/門店名稱",
            "map_store_empty_line1": "該省份暫無門店",
            "map_store_empty_line2": "您可搜索其他省份門店",
            "map_store_empty_area_line1": "該區域暫無門店",
            "map_store_empty_area_line2": "您可搜索其他區域門店",
            "map_store_nav_button": "導航",
            "map_store_overview_button": "整體預覽",
            "map_store_refresh_button": "刷新門店",
            "map_store_all_provinces": "全部省份",
            "map_country_china": "中國",
            "map_country_malaysia": "馬來西亞",
            "map_region_label": "區域",
            "map_loading": "地圖加載中...",
            "map_region_switch_loading": "當前正在加載，請稍候再切換國家",
            "map_popup_auth_date_prefix": "授權日期：",
            "map_popup_distance_prefix": "距離：",
            "map_popup_nav_to": "導航前往",
            "map_popup_copy_address": "複製",
            "map_nav_getting_location": "正在獲取定位…",
            "map_nav_location_unavailable_title": "無法獲取當前位置",
            "map_nav_location_unavailable_message": "無法獲取當前定位，是否繼續導航？您可在地圖中自行輸入起點。",
            "map_nav_continue": "繼續導航",
            "map_nav_cancel": "取消",
            "map_nav_popup_blocked_title": "新窗口被攔截",
            "map_nav_popup_blocked_message": "瀏覽器攔截了新窗口。請點擊下方按鈕打開導航，您將停留在當前地圖頁面。",
            "map_nav_popup_blocked_open": "打開導航",
            "map_nav_popup_blocked_open_current_message": "仍無法打開新窗口，是否在當前頁打開導航？將離開當前地圖頁面。",
            "map_nav_popup_blocked_open_current": "在當前頁打開",
            "map_nav_wechat_browser_title": "請在瀏覽器中打開",
            "map_nav_wechat_browser_message_ios": "微信內無法直接喚起地圖 App。請點擊右上角「···」，選擇「在 Safari 中打開」後，再次點擊導航。",
            "map_nav_wechat_browser_message_android": "微信內無法直接喚起地圖 App。請點擊右上角「···」，選擇「在瀏覽器中打開」後，再次點擊導航。",
            "map_nav_wechat_browser_confirm": "我知道了",
            "map_nav_ios_map_apple": "Apple 地圖",
            "map_nav_ios_map_google": "Google 地圖",
            "map_nav_ios_map_picker_title": "選擇導航應用",
            "map_geo_unsupported": "當前瀏覽器不支持定位",
            "map_geo_failed": "定位失敗",
            "map_geo_permission_denied": "定位權限被拒絕",
            "map_geo_unavailable": "暫時無法獲取位置",
            "map_geo_timeout": "定位超時",
            "map_popup_location_error": "門店位置異常",
            "map_geolocation_watchdog_timeout": "定位超時，已使用默認區域"
        },
        "scheme": {
            "nomoredata": "沒有更多了",
            "author": "作者"
        },
        "schemedetail": {
            "errordata": "數據異常"
        },
        "login": {
            "user_type": "用戶類型",
            "user_type_placeholder": "請選擇用戶類型",
            "phone": "手機號",
            "phone_placeholder": "請輸入手機號",
            "code": "短信驗證碼",
            "code_placeholder": "短信驗證碼",
            "send_code": "發送驗證碼",
            "login": "登錄",
            "phone_verify": "請輸入正確的手機號",
            "imagecode_verify": "請輸入圖形驗證碼",
            "send_code_finish": "驗證碼已發送",
            "code_count": "s後重發",
            "login_success": "登錄成功",
            "user_type_person": "個人",
            "user_type_dealer": "經銷商",
            "captcha": "圖形驗證碼",
            "captcha_placeholder": "圖形驗證碼",
            "user_registe": "用戶註冊",
            "dealer_user_registe": "經銷商用戶註冊",
            "dealer_registe": "經銷商註冊",
            "gotoregister": "請先註冊",
            "selectaccount": "選擇賬號",
            "roleregister": "註冊",
            "input_sms_code": "請輸入短信驗證碼",
            "quick_register_title": "完善資料，完成註冊",
            "quick_register_subtitle": "該手機號尚未註冊\n設定用戶名即可快速註冊登入",
            "quick_register_name_label": "用戶名",
            "quick_register_name_placeholder": "請輸入用戶名",
            "quick_register_name_required": "請先填寫用戶名",
            "quick_register_confirm": "註冊並登入"
        },
        "dealerregister": {
            "dealer_register": "分銷商註冊",
            "dealerType": "經銷商",
            "dealerAddress": "地區選擇",
            "dealerFullAddress": "經銷商地址",
            "dealerName": "經銷商全稱",
            "dealerShortName": "經銷商簡稱",
            "dealerNamePlaceHolder": "請輸入經銷商名稱",
            "userName": "聯繫人姓名",
            "userEmail": "聯繫人郵箱",
            "userPhone": "聯繫人手機號",
            "phone": "手機號",
            "imageCode": "圖形驗證碼",
            "register": "註冊",
            "login": "已有賬戶去登錄",
            "dealerBrand": "經銷商品牌",
            "dealerSuperiorName": "上級分銷商",
            "dealerSuperiorNamePlaceHolder": "如無上級分銷商請忽略",
            "tips": "*提交註冊信息後,需要進行審核和批准.\n(根據情況,由我們的工作人員進行在線審核或現場審核.)",
            "oemdealer": "OEM",
            "dealer": "分銷商",
            "channel": "僅渠道",
            "business_license": "營業執照",
            "business_registration_certificate": "商業登記證",
            "business_license_code": "統一社會信用代碼",
            "business_registration_certificate_code": "商業登記號碼"
        },
        "dealeruserregister": {
            "dealer_user_register": "經銷商用戶註冊",
            "dealerType": "經銷商",
            "dealerTypePlaceHolder": "請選擇經銷商",
            "userName": "姓名",
            "userNamePlaceHolder": "請輸入姓名",
            "userEmail": "郵箱",
            "userEmailPlaceHolder": "請輸入郵箱",
            "userPhone": "手機號",
            "userPhonePlaceHolder": "請輸入手機號",
            "imageCode": "圖形驗證碼",
            "register": "註冊",
            "dealerRegister": "註冊經銷商",
            "login": "已有賬戶去登錄",
            "dealerTypeSelectTips": "沒有經銷商,請先註冊經銷商"
        },
        "userregister": {
            "user_register": "用戶註冊",
            "userName": "姓名",
            "userNamePlaceHolder": "請輸入姓名",
            "userEmail": "郵箱",
            "userEmailPlaceHolder": "請輸入郵箱",
            "userPhone": "手機號",
            "userPhonePlaceHolder": "請輸入手機號",
            "imageCode": "圖形驗證碼",
            "register": "註冊",
            "login": "已有賬號去登陸",
            "register_success": "註冊成功"
        },
        "qa": {
            "qaform": {
                "carinfo": "車輛信息",
                "brand": "車品牌",
                "brandPlaceHolder": "車品牌",
                "carstyle": "車型",
                "carstylePlaceHolder": "車型",
                "carNo": "車牌號",
                "carNoPlaceHolder": "車牌號",
                "carCjNo": "車架號",
                "carCjNoPlaceHolder": "車架號",
                "carOwnerName": "車主姓名",
                "carOwnerNamePlaceHolder": "車主姓名",
                "phoneNumber": "手機號",
                "phoneNumberPlaceHolder": "手機號",
                "ownerphoneNumberPlaceHolder": "車主手機號",
                "productinfo": "產品信息",
                "productName": "產品",
                "productNamePlaceHolder": "產品",
                "productNo": "卷號",
                "productNoPlaceHolder": "卷號",
                "productExpire": "質保",
                "productExpirePlaceHolder": "質保",
                "scanProductInfo": "掃碼獲取產品信息",
                "doForminfo": "裝貼信息",
                "doDate": "日期",
                "doValidDate": "裝貼日期",
                "doDatePlaceHolder": "點擊選擇日期",
                "getProductInfo": "請先獲取產品信息",
                "fullcar": "全選",
                "doCarShop": "門店",
                "doCarShopPlaceHolder": "點擊選擇門店",
                "doPrice": "價格",
                "doPricePlaceHolder": "請輸入實際成交金額",
                "qacarcontent": "質保內容",
                "qacarimage": "裝貼照片",
                "qacarzhengmian": "正面施工照",
                "qacarcemian": "側面施工照",
                "qacarbeimian": "背面施工照",
                "qacarshop": "車輛與店招圖",
                "qacarjuanhao": "清晰卷號圖",
                "qacarjuanhaoandcar": "卷號和車輛照",
                "submit": "提交",
                "qaformsuccess": "創建成功",
                "imagemustsix": "圖片請上傳六張",
                "productinfo_first": "(請先掃碼獲取產品信息)",
                "warranty_days": "天",
                "warranty_year": "年",
                "contact_customer_service": "聯繫客服",
                "contact_customer_service_wechat": "微信客服",
                "contact_customer_service_wechat_click": "點擊聯繫人工客服",
                "contact_customer_service_phone": "電話客服"
            },
            "qasearch": {
                "searchcontent": "通過手機號搜索質保卡",
                "phone": "手機號",
                "phonePlaceHolder": "請輸入手機號",
                "imageCode": "圖形驗證碼",
                "imageCodePlaceHolder": "圖形驗證碼",
                "search": "搜索",
                "qalist": "質保列表",
                "noqatips": "當前手機號暫無質保"
            },
            "qareview": {
                "reviewtab": "未審核",
                "reviewing": "審核中",
                "success": "已審核",
                "failed": "已駁回",
                "submitsuccess": "提交成功",
                "submit": "提交",
                "reviewsuccess": "審核通過",
                "reviewfailed": "審核拒絕",
                "review": "審核",
                "dateStart": "日期從",
                "dateEnd": "日期到",
                "searchtips": "模糊搜索",
                "searchtipsPlaceHolder": "請輸入關鍵詞",
                "search": "搜索",
                "reject_reason": "拒絕理由",
                "reject_reason_placeholder": "請輸入拒絕理由"
            },
            "qadetail": {
                "carinfo": "車輛信息",
                "brand": "車品牌",
                "carstyle": "車型",
                "carNo": "車牌號",
                "carCjNo": "車架號",
                "carOwnerName": "車主姓名",
                "phoneNumber": "手機號",
                "productinfo": "產品信息",
                "productName": "產品",
                "productNo": "卷號",
                "productExpire": "質保",
                "doForminfo": "裝貼信息",
                "doDate": "日期",
                "doPart": "裝貼部位",
                "doCarShop": "門店",
                "doPrice": "價格",
                "qacarcontent": "質保內容",
                "qacarimage": "裝貼照片",
                "qacarzhengmian": "正面施工照",
                "qacarcemian": "側面施工照",
                "qacarbeimian": "背面施工照",
                "qacarshop": "車輛與店招圖",
                "qacarjuanhao": "清晰卷號圖",
                "qacarjuanhaoandcar": "卷號和車輛照"
            },
            "qaitem": {
                "id": "質保卡ID",
                "warrantyCode": "質保編碼",
                "starttime": "質保開始日期",
                "createtime": "質保創建日期",
                "car": "汽車",
                "product": "產品",
                "status_not_confired": "未確認",
                "status_confirming": "確認中",
                "status_confirmed": "已確認",
                "status_rejected": "已駁回"
            }
        },
        "stock": {
            "stockin": "庫存中",
            "stockrecord": "入庫記錄",
            "stockused": "已出庫",
            "stockunin": "待入庫",
            "stockinsuccess": "入庫成功",
            "stockoutsuccess": "出庫成功",
            "stockscancode": "掃碼入庫",
            "stockid": "庫存ID",
            "stock_stock_in": "入庫",
            "stock_stock_out": "出庫"
        },
        "language": {
            "btn_complete": "完成",
            "switch_label": "語言切換",
            "simplified": "簡體中文",
            "traditional": "繁體中文",
            "english": "English",
            "malay": "Bahasa Melayu"
        },
        "mine": {
            "username": "用戶名",
            "changerole": "切換角色",
            "changerolddesc": "是否要切換角色",
            "norolecanchagen": "沒有角色可切換"
        },
        "mineitem": {
            "myqaitem": "我的質保",
            "mysecuritycheckitem": "序列號校驗",
            "myshopitem": "我的採購計劃",
            "mystockitem": "庫存管理",
            "mygoodsitem": "發貨管理",
            "myqareviewitem": "質保管理",
            "mydealermanageritem": "分銷商/零售商管理",
            "myconstructionitem": "施工管理",
            "mycouponitem": "我的券碼",
            "couponmanageitem": "券碼管理",
            "mycouponcheckitem": "券碼核銷",
            "mycouponreportitem": "券碼報表",
            "myinstructionitem": "說明書",
            "mylanguageitem": "語言切換",
            "mychartqaitem": "質保報表",
            "mychartpurchaseorderitem": "採購單報表",
            "workerlist": "員工管理",
            "workerdetail": "員工信息",
            "mystockinitem": "入庫管理",
            "mycreatestockitem": "創建庫存",
            "mystockoutitem": "出庫管理",
            "mycreateqaitem": "創建質保",
            "myqueryqaitem": "質保查詢",
            "myclaimitem": "索賠",
            "myclaimapprovalitem": "索賠審批",
            "mycompensationitem": "賠付管理",
            "myorderitem": "下級採購計劃管理",
            "mylogout": "退出登錄",
            "myloginin": "登錄",
            "mypaymentorderitem": "採購下單",
            "mypaymentordermanageritem": "採購訂單管理",
            "mypaymentorderbillmanageritem": "付款單管理",
            "myproductpurchaseitem": "商品購買",
            "wechat_purchase_hint": "微信內無法直接喚起支付寶，可點擊右上角「···」選擇「在瀏覽器打開」後選擇商品進行支付",
            "myservicecentermanager": "服務網點管理",
            "addressmanager": "地址管理",
            "warehousemanager": "倉庫管理",
            "reportmanager": "經營報表",
            "storemanager": "店鋪管理",
            "myservicepurchase": "服務購買"
        },
        "nav": {
            "qalist": "質保列表",
            "qacreate": "質保創建",
            "securitycheck": "序列號校驗",
            "qadetail": "質保詳情",
            "showlist": "採購列表",
            "showorderlist": "交易列表",
            "storelist": "店鋪列表",
            "showorder": "採購下單",
            "shopdetail": "採購詳情",
            "shoporderdetail": "交易詳情",
            "stock": "庫存管理",
            "stockin": "入庫管理",
            "stockout": "出庫管理",
            "purchase": "發貨管理",
            "purchasedetail": "發貨詳情",
            "qareview": "質保管理",
            "dealershopmanager": "分銷商/零售商管理",
            "dealershopmanagerdetail": "詳情",
            "qasearch": "質保搜索",
            "qapublicquery": "汽車膜質保查詢",
            "register": "註冊",
            "scancode": "掃碼",
            "detail": "詳情",
            "languagechange": "語言切換",
            "storecreate": "門店創建",
            "dealercreate": "經銷商創建",
            "construction": "施工管理",
            "construction_pending": "待施工",
            "construction_completed": "施工完成",
            "construction_accepted": "施工驗收",
            "construction_detail": "施工詳情",
            "coupon": "我的券碼",
            "coupon_manage": "券碼管理",
            "coupon_detail": "券碼詳情",
            "coupon_check": "券碼核銷",
            "charts_coupon": "券碼報表",
            "manual": "說明書",
            "charts_qa": "質保報表",
            "charts_po": "採購單報表",
            "charts_inoutstock": "出入庫報表",
            "role_select": "選擇身份",
            "dealer_register": "分銷商註冊",
            "direct_vender_register": "直營商註冊",
            "dealer_shop_register": "零售商註冊",
            "service_provider_register": "服務商註冊",
            "register_address_map": "選擇具體地址",
            "dealer_worker_register": "分銷商員工註冊",
            "service_worker_register": "服務商員工註冊",
            "shop_worker_register": "零售商員工註冊",
            "consumer_user_register": "用戶註冊",
            "qrcode_register": "掃碼註冊",
            "workerlist": "員工管理",
            "workerdetail": "員工信息",
            "purchase_order": "訂單管理",
            "purchase_order_detail": "訂單詳情",
            "in_stock_detail": "入庫詳情",
            "paymentorderbill": "付款單列表",
            "paymentorderbilldetail": "付款單詳情",
            "scandetail": "掃碼詳情",
            "stockoutdetail": "出庫詳情",
            "stockindetail": "入庫詳情",
            "stockstockdetail": "庫存詳情",
            "servicecentermanager": "服務網點管理",
            "servicecentercreate": "服務網點創建",
            "servicecenterdetail": "服務網點信息",
            "addressmanager": "地址管理",
            "addresscreate": "創建地址",
            "addressdetail": "詳情",
            "warehousemanager": "倉庫管理",
            "warehousecreate": "創建倉庫",
            "ordersummary": "訂單彙總",
            "orderproductout": "發貨管理",
            "chartslist": "經營報表",
            "servicepurchase": "服務購買",
            "paysuccess": "支付成功",
            "servicelistmanager": "服務訂單管理",
            "consumer_order_detail": "訂單詳情",
            "consumer_order_list": "訂單管理",
            "consumer_order_info": "訂單詳情",
            "consumer_payment_bill_list": "付款單管理",
            "consumer_payment_bill_info": "付款單詳情",
            "consumer_store_list": "選擇店鋪",
            "consumer_shop": "選擇商品",

            "claimlist": "索賠列表",
            "claimapply": "索賠申請",
            "claimdetail": "索賠詳情",
            "claimapproval": "索賠審批",
            "claimapprovaldetail": "審批詳情",
            "compensation": "賠付管理",
            "compensationdetail": "賠付詳情"
        },

        // 索賠詳情
        "claimdetail": {
            "claimstatus": "索賠狀態",
            "statuspending": "待審核",
            "statusapproved": "已審核",
            "statusrejected": "已駁回",
            "loading": "加載中…",
            "applytime": "申請時間",
            "approval_time": "審核時間",
            "approval_opinion": "審核意見",
            "productinfo": "產品信息",
            "productname": "產品名稱",
            "product_category": "產品類目",
            "serialnumber": "卷號",
            "compensation_party": "賠付方信息",
            "compensation_type": "賠付方類型",
            "compensation_name": "賠付方名稱",
            "warranty_info": "關聯質保",
            "warranty_code": "質保編號",
            "valid_period": "有效期",
            "phone": "手機號",
            "questionnaire": "問卷信息",
            "media": "圖片與視頻",
            "notfound": "未找到該索賠記錄",
            "video_load_failed": "視頻加載失敗，請稍後重試"
        },

        // 索賠審批
        "claimapproval": {
            "all": "全部",
            "pending": "待審核",
            "approved": "已審核",
            "rejected": "已駁回",
            "id": "ID",
            "product_name": "產品名稱",
            "serial_number": "卷號",
            "claim_party": "索賠方",
            "warranty_code": "質保編號",
            "empty": "暫無{label}記錄",
            "emptyall": "暫無記錄",
            "viewdetail": "點擊查看詳情並審批"
        },

        // 索賠審批詳情
        "claimapprovaldetail": {
            "flow_submitted": "已提交",
            "claim_party_info": "索賠方信息",
            "claim_party": "索賠方",
            "approve": "通過",
            "reject": "駁回",
            "approve_title": "通過申請",
            "approve_placeholder": "請填寫通過原因…",
            "approve_required": "請填寫通過原因",
            "reject_title": "駁回申請",
            "reject_placeholder": "請填寫駁回原因…",
            "reject_confirm": "確認駁回",
            "cancel": "取消",
            "approve_confirm": "確認通過",
            "reject_required": "請填寫駁回原因",
            "approve_success": "已通過",
            "reject_success": "已駁回",
            "operate_failed": "操作失敗，請稍後重試"
        },

        // 索賠申請
        "claimapply": {
            "claim_type": "索賠類型",
            "link_warranty": "關聯質保",
            "product_no": "商品卷號",
            "product_info": "產品信息",
            "questionnaire": "問卷信息",
            "required_select": "必選",
            "required_fill": "必填",
            "type_warranty": "質保關聯",
            "type_product": "商品索賠",
            "select_warranty_placeholder": "選擇質保記錄",
            "manual_input": "手動輸入",
            "scan_input": "掃碼獲取",
            "product_no_placeholder": "請輸入卷號",
            "verify": "驗證",
            "scan_hint": "點擊掃碼獲取卷號",
            "product_category": "產品類目",
            "product_name": "產品名稱",
            "serial_number": "卷號",
            "compensation_party": "賠付方信息",
            "compensation_type": "賠付方類型",
            "compensation_name": "賠付方名稱",
            "input_placeholder": "請輸入",
            "file_type_image": "圖片",
            "file_type_video": "視頻",
            "multi_select_hint": "(可多選)",
            "check_questionnaire": "請檢查問卷內容是否填寫正確",
            "submit": "提交索賠",
            "select_warranty": "選擇質保",
            "close": "關閉",
            "loading": "加載中…",
            "warranty_code": "質保編號",
            "valid_period": "有效期",
            "product": "產品",
            "phone": "電話",
            "vin": "車架號",
            "warranty_empty": "未找到匹配的質保記錄",
            "file_min": "最少 {n} 個",
            "file_max": "最多 {n} 個",
            "file_range": "最少 {min} 個，最多 {max} 個",
            "error_required": "此項為必填項",
            "error_length": "字數需在 {min}~{max} 之間",
            "error_number": "數值需在 {min}~{max} 之間",
            "error_format": "格式不正確",
            "error_file_min": "至少上傳 {n} 個文件",
            "error_file_max": "最多上傳 {n} 個文件",
            "toast_select_claim_type": "請選擇索賠類型",
            "toast_select_warranty": "請選擇關聯的質保記錄",
            "toast_product_no": "請輸入或掃碼獲取商品卷號",
            "toast_verify_failed": "卷號校驗失敗",
            "toast_verify_success": "驗證成功",
            "toast_submit_success": "索賠申請已提交",
            "toast_submit_failed": "提交失敗，請稍後重試"
        },

        // 索賠列表
        "claimlist": {
            "all": "全部",
            "pending": "待審核",
            "approved": "已審核",
            "rejected": "已駁回",
            "serial_number": "卷號",
            "compensation_party": "賠付方",
            "warranty_code": "質保編號",
            "approval_opinion": "審核意見",
            "id": "ID",
            "product_name": "產品名稱",
            "empty": "暫無{label}記錄",
            "emptyall": "暫無記錄",
            "empty_sub": "遇到產品不良問題，可發起索賠申請",
            "create": "發起索賠"
        },

        // 消費者掃碼訂單（個人消費者）
        "consumerorder": {
            "order_no": "訂單號",
            "product_list": "商品清單",
            "product_amount": "商品金額",
            "freight": "運費",
            "freight_free": "免運費",
            "total_amount": "合計",
            "pay_amount": "應付金額",
            "create_order": "創建訂單",
            "create_payment": "創建付款單",
            "first_select_address": "請先選擇收貨地址",
            "order_success": "下單成功",
            "go_to_payment": "是否現在支付？",
            "payment_confirm": "去支付",
            "payment_back": "稍後",
            "payment_method": "支付方式",
            "payment_success": "支付成功",
            "payment_failed": "支付發起失敗，請稍後重試",
            "alipay_querying": "正在查詢支付結果，請稍候…",
            "alipay_back": "返回",
            "alipay_scan_tip": "請使用支付寶掃碼支付",
            "alipay_scan_sub": "支付完成後將自動檢測",
            "company_name": "公司名稱",
            "bank_name": "開戶行",
            "bank_account": "銀行賬號",
            "payment_time": "付款時間",
            "payment_time_now": "當前時間",
            "payment_time_manual": "手動調整",
            "select_full_date": "選擇完整時間",
            "search_order_placeholder": "請輸入訂單ID查詢",
            "tab_all": "全部",
            "tab_unpay": "待付款",
            "tab_unconfirmed": "待確認",
            "tab_partpay": "部分付款",
            "tab_payed": "已確認",
            "tab_confirmed": "已確認",
            "tab_closed": "已關閉",
            "status_confirmed": "已確認",
            "status_pending_payment": "待付款",
            "status_confirming": "待確認",
            "payment_bill_manage": "付款單管理",
            "search_bill_placeholder": "請輸入付款單ID查詢",
            "payment_bill_id": "付款單ID",
            "transaction_no": "交易流水號",
            "payment_subject_type": "付款主體類型",
            "payment_subject": "付款主體",
            "receive_account": "收款賬戶",
            "payment_amount": "付款金額",
            "order_id": "訂單ID",
            "order_person": "下單人",
            "order_date": "下單時間",
            "order_info": "訂單信息",
            "order_status": "訂單狀態",
            "order_time": "下單時間",
            "price_detail": "金額明細",
            "really_pay": "實付金額",
            "order_payment": "付款單信息",
            "related_order": "關聯訂單",
            "create_pay_time": "創建時間",
            "payment_date": "付款時間",
            "confirm_date": "確認時間",
            "loading": "載入中…",
            "empty": "暫無相關訂單",
            "empty_hint": "換個狀態看看，或掃碼下單",
            "retailer": "零售商",
            "retailer_id": "零售商ID",
            "includes": "包含",
            "logistics_need": "需物流",
            "logistics_none": "無需物流",
            "logistics_optional": "可選物流",
            "delivery_title": "收貨方式",
            "delivery_need": "需要寄送",
            "delivery_none": "不需要寄送",
            "no_delivery_hint": "本單無需寄送",
            "no_delivery_desc": "無需填寫收貨地址，可直接建立訂單",
            "leave_confirm": "離開後需重新掃碼進入本頁",
            "leave_confirm_ok": "確認離開",
            "leave_confirm_cancel": "留在本頁",
            "consumer_only_hint": "本頁面僅供個人消費者使用，當前帳號無法訪問",
            "consumer_only_confirm": "確定",
            "data_error": "數據異常",
            "retailer_select_title": "選擇零售商",
            "retailer_placeholder": "請選擇零售商",
            "retailer_search_placeholder": "搜尋門店名稱",
            "retailer_locating": "正在取得定位…",
            "retailer_empty": "找不到相關零售商",
            "shop_search_placeholder": "搜尋店鋪名稱",
            "shop_empty": "找不到相關店鋪",
            "empty_product": "暫無商品",
            "retailer_required": "請先選擇零售商",
            "retailer_change": "更換",
            "alipay_wechat_guide_title": "請到瀏覽器中開啟完成付款",
            "alipay_wechat_guide_desc": "微信內無法直接喚起支付寶，請依下列步驟操作",
            "alipay_wechat_guide_step1": "點擊右上角「···」",
            "alipay_wechat_guide_step2": "選擇「在瀏覽器中開啟」",
            "alipay_wechat_guide_step3": "重新點擊「去支付」完成付款",
            "alipay_wechat_pay_message": "微信內無法直接喚起支付寶，可點擊右上角「···」選擇「在瀏覽器中開啟」後重新付款，或改用銀行轉帳付款。",
            "alipay_wechat_pay_confirm": "我知道了"
        },
        "shop": {
            "order": "下單",
            "clearcart": "清空購物車",
            "selectall": "全選",
            "addCart": "請先選擇規格",
            "shopsuccess": "下單成功",
            "addToCartFirst": "請先加入購物車",
            "shoplistid": "採購單ID",
            "showlisttime": "採購日期",
            "showlistdealer": "經銷商",
            "showlistphone": "採購人手機號",
            "getshop": "採購",
            "addToCart": "加入購物車",
            "product_detail": "商品詳情",
            "no_detail": "暫無詳情",
            "view_detail": "查看詳情",
            "allproduct": "數量",
            "allprice": "總計",
            "order_status_unreview": "核款中",
            "price_begin": "起",
            "nopermission": "非代理商用戶無權查看商品信息",
            "popup_confirm": "回到官網",
            "popup_changerole": "切換角色",
            "purchase_people": "採購人",
            "purchase_from": "採購商",
            "confirm_order": "確認下單"
        },
        "account": {
            "title": "匯款賬戶信息",
            "companynametitle": "公司名稱",
            "companynamevalue": "上海廣臺喬子實業發展有限公司",
            "tintitle": "納稅人識別號",
            "tinvalue": "91310118560192303A",
            "addresstitle": "地址",
            "addressvalue": "青浦區朱家角鎮祥凝浜路16弄45號320室",
            "phonetitle": "電話",
            "phonevalue": "64188908",
            "banktitle": "開戶銀行",
            "bankvalue": "農業銀行上海威海路支行",
            "accounttitle": "匯款帳號",
            "accountvalue": "03304700040011734",

            "merchantnotitle": "商戶號",
            "parentmerchantnotitle": "平台商戶號",
            "nopaymentmethod": "暫無付款方式",
            "alipay": "支付寶",
            "banktransfer": "銀行轉賬",
            "tips": "*下單以後,匯款賬戶信息在採購詳情頁面可查"
        },
        "purchase": {
            "dateStart": "日期從",
            "dateEnd": "日期到",
            "searchtips": "模糊搜索",
            "searchtipsPlaceHolder": "請輸入關鍵詞",
            "search": "搜索",
            "unpurchase": "未發貨",
            "purchased": "已發貨",
            "scanstockout": "掃碼出庫",
            "id": "採購單ID",
            "time": "採購時間",
            "dealer": "採購經銷商",
            "dealerphonenumber": "採購用戶手機號",
            "dealername": "經銷商名稱",
            "dealeraddress": "經銷商地址",
            "dealercontactname": "聯繫人姓名",
            "dealercontactphone": "聯繫人手機號",
            "dealerinfo": "經銷商信息",
            "productinfo": "產品信息",
            "gopurchase": "採購",
            "search_input_purchase_placeholder": "請輸入採購單ID查詢",
            "purchase_list": "採購列表",
            "to_now": "至今"
        },
        "purchasedetail": {
            "goodsinfo": "商品信息",
            "bankinfo": "匯款信息"
        },
        "securitycheck": {
            "securitycheckscancode": "掃碼查真偽",
            "productscan": "產品序列號",
            "resultsuccess": "正品無誤",
            "resulterror": "假冒商品",
            "resulterrortwo": "暫未查詢到該序列號",
            "resulterrordetail": "系統當前無法匹配您輸入的序列號,建議您聯絡您的零售商或聯繫上級分銷商進行人工核對,以獲取詳細的產品反饋.",
            "tips": "註冊電子質保後享有官方質保及不同增值服務",
            "thanks": "恭喜您,該產品為嘉實多汽車膜產品正品\n感謝您的支持!",
            "thankserror": "請聯繫官方處理",
            "thankserrortwo": "系統當前無法匹配您輸入的序列號\n建議您聯絡您的零售商或聯繫上級分銷商進行人工核對,以獲取詳細的產品反饋.",
            "jump": "跳轉",
            "productverify": "產品真偽驗證",
            "productstyle": "產品型號",
            "expire": "質保期限",
            "qacreate": "創建質保"
        },
        "qrcode": {
            "cameraname": "攝像頭",
            "selectcamera": "選擇攝像頭",
            "tips": "掃碼有問題?點擊切換攝像頭",
            "btntips": "切換",
            "fromalbum": "從相冊選擇",
            "imageverifyerror": "圖片識別失敗",
            "initerror": "解析器初始化失敗",
            "changecamera": "切換攝像頭",
            "album": "相冊",
            "scan_end": "結束掃碼",
            "scan_preview": "掃碼預覽",
            "scan_summary": "掃碼彙總",
            "scan_success": "掃碼成功",
            "please_scan_first": "請先掃碼",
            "barcodetips": "請將條形碼對準框內進行掃描",
            "verify_success": "校驗成功"
        },
        "dealershopmanager": {
            "dealername": "分銷商",
            "shopname": "門店",
            "retailer": "零售商",
            "item": {
                "id": "ID",
                "fullname": "全稱",
                "address": "地址"
            },
            "detail": {
                "id": "ID",
                "fullname": "全稱",
                "address": "地址",
                "shortname": "簡稱",
                "brand": "品牌",
                "level": "級別",
                "createtime": "創建時間"
            },
            "createshop": "創建門店",
            "createdealer": "創建分銷商",
            "createretailer": "創建零售商",
            "search_name": "請輸入名稱搜索",

            "type": {
                "picker_title": "選擇零售商類型",
                "picker_subtitle": "請選擇要創建的零售商類型",
                "retailer": "普通零售商",
                "retailer_desc": "具備銷售與施工能力",
                "sales_only": "僅銷售零售商(N 店)",
                "sales_only_desc": "僅負責銷售，不參與施工",
                "sales_only_short": "僅銷售",
                "cancel": "取消"
            },
            "shop": {
                "title": "門店詳情",
                "shopinfo": "門店信息",
                "shopname": "門店簡稱",
                "shopfullname": "門店全稱",
                "shopaddress": "門店地址",
                "shopphonenumber": "聯繫人手機號",
                "submit": "提交",
                "verifyone": "營業執照",
                "dealerfullname": "經銷商全稱",
                "dealerlevel": "經銷商級別",
                "verifyonefront": "文件",
                "verifyoneback": "文件",
                "verifyoneshopimg": "文件",
                "emptytips": "資料填寫不全",
                "submitsuccess": "資料提交成功,審核中......",
                "storeaddress": "門店地址"
            },
            "dealer": {
                "dealerinfo": "經銷商信息",
                "title": "經銷商詳情",
                "submit": "提交",
                "nomoreimages": "最多上傳三張照片",
                "submitsuccess": "資料提交成功,審核中......"
            },
            "tips": "*提交創建信息後,需要進行審核和批准.\n(根據情況,由我們的工作人員進行在線審核或現場審核.)",
            "businessLicenseNumber": "營業執照號碼"
        },
        "construction": {
            "order_available": "可接單",
            "order_pending_construction": "待施工",
            "order_under_construction": "施工中",
            "order_construction_completed": "施工完成",
            "order_accepted": "已驗收",
            "order_cancelled": "已取消",
            "accepted": "驗收",
            "item": {
                "order_id": "訂單號",
                "color": "顏色",
                "car_style": "車型",
                "dealer": "經銷商",
                "construction_address": "施工地址",
                "construction_time_area": "施工時間範圍",
                "selected_construction_time": "已選施工時間",
                "construction_people": "施工人員",
                "under_construction_btn_before": "提前施工",
                "under_construction_btn_after": "開始施工"
            },
            "pedding_construction": {
                "title": "是否開始施工",
                "cancel": "取消",
                "confirm": "確定"
            },
            "constructioncompleted_detail": {
                "title": "請上傳施工後車輛照片",
                "image": "圖片",
                "cell_title": "交接車檢測項目",
                "defect_name": "缺陷名稱",
                "bubble": "氣泡",
                "impurity": "雜質",
                "offset_printing": "膠印",
                "indicates_scratch": "表明刮傷",
                "surface_wrinkle": "表面褶皺",
                "surface_damage": "表面破損",
                "warranty_upload": "質保上傳",
                "construction_completed": "施工完成",
                "pedding_construction_accepted": "等待車主驗車",
                "before_completed_tips": "請先上傳簽字驗收單圖片",
                "cancel": "取消",
                "confirm": "確定"
            },
            "constructionaccepted_detail": {
                "cell_title": "交接車檢測項目",
                "defect_name": "缺陷名稱",
                "bubble": "氣泡",
                "impurity": "雜質",
                "offset_printing": "膠印",
                "indicates_scratch": "表明刮傷",
                "surface_wrinkle": "表面褶皺",
                "surface_damage": "表面破損",
                "warranty_upload": "質保上傳",
                "images_title": "施工後照片",
                "accepted": "驗收",
                "construction_completed": "施工完成",
                "before_completed_tips": "請上傳施工後車輛照片",
                "pedding_construction_accepted": "是否驗收通過",
                "cancel": "取消",
                "confirm": "驗收通過",
                "completed_photos": "施工完成照片",
                "owner_qrcode_photos": "車主驗收二維碼"
            },
            "construction_detail": {
                "title": "施工單詳情",
                "order_id": "訂單號",
                "color": "顏色",
                "car_style": "車型",
                "construction_time_area": "施工時間範圍",
                "construction_address": "施工地址",
                "selected_construction_time": "選定施工時間",
                "salespeople_phonenumber": "銷售人員手機號",
                "owner_phonenumber": "車主手機號",
                "worker": "施工人員",
                "construction_part": "施工部位",
                "comment": "評論",
                "images_title": "施工完成照片",
                "owner_images_title": "施工驗收照片"
            }
        },
        "coupon": {
            "nav": {
                "unused": "待使用",
                "used": "已使用",
                "invalid": "已失效",
                "dealer_unused": "已發放",
                "dealer_used": "已核銷",
                "dealer_invalid": "已失效"
            },
            "detail": {
                "id": "ID",
                "verificationcode": "核銷碼",
                "name": "優惠券",
                "phone": "用戶手機號",
                "store": "適用門店",
                "usedstore": "使用門店",
                "date": "適用日期",
                "state": "狀態",
                "check_time": "核銷時間",
                "detail": "詳情",
                "qrcode_title": "核銷二維碼"
            },
            "check": {
                "securitycheckscancode": "券碼核銷",
                "productscanstate": "核銷狀態",
                "coupon_id": "券碼ID",
                "coupon_verificationcode": "券碼核銷碼",
                "coupon_name": "券碼名稱",
                "coupon_address": "使用地點",
                "coupon_scan_date": "核銷時間",
                "coupon_check_yes": "核銷成功",
                "coupon_check_no": "核銷失敗",
                "nav_check": "券碼核銷",
                "nav_list": "核銷記錄"
            }
        },
        "mainbody": {
            "dealername": {
                "top_title": "請輸入您要註冊的商戶/公司全稱",
                "tips": "*請仔細填寫確保名稱和營業執照一致",
                "label": "商戶/公司全稱",
                "bottom_content": "下一步"
            },
            "dealer": {
                "toptitle": "請填寫商戶/公司資料",
                "dealertype": "類型",
                "fullname": "商戶/公司全稱",
                "filetype": "證件類型",
                "filetype_placeholder": "統一社會信用代碼",
                "file_image": "證件照片",
                "bottom_content": "下一步",
                "select_region_first": "請先選擇國家/省/市/區",
                "region_label": "已選地區",
                "locate_on_map": "定位",
                "drag_marker_hint": "輸入具體地址後點擊定位；若位置不準，可拖動地圖標記微調",
                "locate_building_approximate": "已定位到小區範圍，天地圖暫無該樓棟精確座標，請拖動標記到具體樓棟",
                "longitude": "經度",
                "latitude": "緯度",
                "confirm_address": "確定地址",
                "enter_detail_address": "請輸入具體地址",
                "locate_failed": "地址定位失敗，請檢查地址或手動拖動標記",
                "confirm_address_invalid": "請先輸入具體地址並在地圖上確認位置",
                "detail_address_title": "請輸入具體地址",
                "detail_address_subtitle": "建議填寫到樓棟/門牌；樓層室號不影響定位，可手動拖動標記微調",
                "map_placeholder": "請先輸入具體地址並點擊「定位」，地圖將在此顯示",
                "map_style_streets": "標準",
                "map_style_hybrid": "衛星",
                "map_switched_satellite": "鄉村地區已切換衛星地圖，可查看實際地貌",
                "map_panel_tianditu": "天地圖選點",
                "map_panel_maptiler": "MapTiler",
                "map_panel_maptiler_compare": "MapTiler 對比（只讀）",
                "map_compare_hint": "臨時雙地圖對比 · 以天地圖座標為準 · 拖動天地圖標記後 MapTiler 同步顯示",
                "geocode_result_title": "定位結果",
                "geocode_input_address": "輸入地址",
                "geocode_matched_address": "匹配地址",
                "geocode_source": "解析來源",
                "geocode_coord_system": "座標系",
                "geocode_lnglat_pair": "lng,lat",
                "geocode_level": "精度級別",
                "geocode_manual_adjusted": "已手動調整",
                "geocode_approximate": "近似定位",
                "geocode_copy_lnglat": "複製座標",
                "geocode_copy_success": "座標已複製",
                "geocode_source_tianditu": "天地圖",
                "geocode_source_maptiler": "MapTiler"
            },
            "dealeruser": {
                "toptitle": "請填寫聯繫人資料",
                "desc": "即可完成註冊",
                "fill_real_name": "請填寫真實姓名",
                "fill_fake_name": '請填寫用戶名',
                "fill_captcha": "請輸入圖形驗證碼",
                "fill_sms_code": "請輸入短信驗證碼",
                "register": "註冊"
            },
            "directvendor": {
                "top_title": "請輸入您要註冊的直營商全稱",
                "label": "直營商全稱"
            }
        },
        "roleselect": {
            "title": "感謝您選擇嘉實多",
            "desc": "請選擇您要註冊的身份",
            "topdealer": "一級分銷商",
            "directvendor": "直營商",
            "service": "服務商",
            "consumer": "消費者",
            "serviceprovider": "服務人員",
            "other": "其他"
        },
        "qrcoderegister": {
            "scan_desc": "掃一掃二維碼圖案,成為",
            "retailer_name": "零售商",
            "dealer_name": "分銷商",
            "download": "下載",
            "user": "掃一掃二維碼圖案,加入企業",
            "copy": "點擊複製鏈接",
            "copysuccess": "複製成功",
            "copyfail": "複製失敗"
        },
        "worker": {
            "submit_in": "錄入員工",
            "topsearch": {
                "title": "請輸入員工手機號查詢"
            },
            "item": {
                "user": "用戶名",
                "phone": "手機號"
            },
            "detail": {
                "id": "員工ID",
                "name": "真實姓名",
                "phone": "手機號",
                "delete": "刪除員工",
                "deletepopup": {
                    "title": "確定要刪除該員工嗎?",
                    "confirm": "確定",
                    "cancel": "取消"
                }
            }
        },
        "serviceprovider": {
            "fulladdress": "具體地址",
            "belongserviceproviderinfo": "所屬服務商"
        },
        "distributor": {
            "tipsone": "當前上級分銷商不存在",
            "tipstwo": "當前上級分銷商數據解析異常",
            "parentinfo": "所屬分銷商"
        },
        "retailer": {
            "tipsone": "所屬零售商不存在",
            "tipstwo": "所屬零售商數據解析異常",
            "parentinfo": "所屬分銷商",
            "belongshopinfo": "所屬零售商"
        },
        "supplier": {
            "tipsone": "所屬供應商不存在",
            "tipstwo": "所屬供應商數據解析異常",
            "parentinfo": "所屬供應商",
            "item": {
                "type": "類型"
            },
            "tips": {
                "warn": {
                    "outboundtargettips": "請先選擇出庫目標"
                }
            }
        },
        "directvendor": {
            "tipsone": "所屬直營商不存在",
            "tipstwo": "所屬直營商數據解析異常",
            "parentinfo": "所屬直營商"
        },
        "loginroleselect": {
            "title": "請選擇一個身份進行登錄",
            "desc": "檢測到您有多個身份,登錄後可切換",
            "system_user": "系統用戶",
            "supplier_user": "供應商",
            "distributor_user": "分銷商",
            "directvendor_user": "直營商",
            "retailer_user": "零售商",
            "individual_user": "消費者",
            "service_provider_user": "服務商",
            "service_personnel": "服務人員"
        },
        "newstock": {
            "create": {
                "addToStockDetail": "加入庫存彙總",
                "clearAllStockDetail": "清空庫存彙總",
                "createstock": "創建庫存",
                "addToStockDetailFirst": "請先加入庫存彙總",
                "serialnumber": " 序列號",
                "enterserialnumber": "請輸入序列號",
                "tips": {
                    "batch_input_tips": "請批量輸入序列號,使用換行來分割",
                    "input_serialnumber": "請輸入序列號",
                    "check_all_count": "識別總數量:"
                },
                "detail": {
                    "gostock": "入庫",
                    "serialnumberlist": "序列號列表",
                    "success": "創建成功",
                    "failed": "創建失敗",
                    "instock_success": "入庫成功",
                    "no_create_success_stock": "暫無創建成功的庫存"
                }
            },
            "in": {
                "title_unstockin": "待入庫",
                "title_stockrecord": "入庫記錄",
                "title_querystock": "查看庫存",
                "scan_stock_in": "掃碼入庫",
                "search_placeholder": "請輸入卷號查詢",
                "in_stock_date": "入庫日期",
                "un_in_stock_count": "待入庫總數",
                "in_stock_record_count": "入庫記錄總數",
                "plan_purchase_count": "採購總數",
                "real_in_count": "實際入庫總數",
                "select_purchase_distributor": "請選擇上級分銷商",
                "select_warehouse": "倉庫選擇",
                "confirm_select": "確認選擇",
                "skip_without_create_warehouse": "跳過(默認主倉)",
                "inconfirm": {
                    "confirm_in": "確定入庫",
                    "error_popup": "異常,請重新確定後再入庫,其餘卷芯號入庫成功",
                    "error_popup_one": "異常,請重新確定後再入庫",
                    "error_popup_two": "該產品不在入庫範圍內,請檢查後重新操作",
                    "error_popup_three": "某些卷號不在入庫範圍內,請檢查後重新操作",
                    "newscan": "重新掃碼",
                    "in_success": "入庫成功",
                    "novalid_in": "無效錄入"
                },
                "stock": {
                    "count": "數量:",
                    "stock_all_count": "庫存總數:",
                    "stockin": "已入庫",
                    "info": "流轉信息",
                    "instock": "庫存中",
                    "instock_time": "入庫時間",
                    "warehouse_name": "倉庫全稱"
                }
            },
            "out": {
                "title_unstockout": "待出庫",
                "title_stockrecord": "出庫記錄",
                "title_querystock": "查看庫存",
                "search_placeholder": "請輸入卷號查詢",
                "title": "時間:",
                "out_stock_time": "出庫日期",
                "out_stock_time_two": "出庫時間",
                "out_stock_record_count": "出庫記錄總數",
                "plan_purchase_count": "採購總數",
                "real_out_count": "實際出庫總數",
                "unout": {
                    "select_purchase_distributor": "請選擇採購分銷商/零售商",
                    "select_outbount_targetobject": "請選擇出庫目標",
                    "scan_out": "掃碼出庫",
                    "summary_kind_label": "產品種類",
                    "summary_kind_unit": "款",
                    "summary_pending_label": "待出庫合計",
                    "no_select_distributor": "請先選擇分銷商",
                    "no_select_targetobject_desc": "請先選擇出庫目標",
                    "search_outbound_target_name": "請輸入名稱搜索",
                    "distributor_un_out_count": "該分銷商/零售商待出庫數量",
                    "targetobject_un_out_count": "該出庫目標待出庫數量",
                    "out_count": "出庫數量",
                    "plannedpurchase_count": "計劃採購數量",
                    "out_count_new": "實際出庫數量",
                    "plannedpurchase_count_new": "採購數量"
                },
                "outconfirm": {
                    "confirm_in": "確定出庫",
                    "error_popup": "異常,請重新確定後再出庫,其餘卷芯號出庫成功",
                    "error_popup_one": "異常,請重新確定後再出庫",
                    "error_popup_two": "該產品不在出庫範圍內,請檢查後重新操作",
                    "error_popup_three": "某些卷號不在出庫範圍內,請檢查後重新操作",
                    "newscan": "重新掃碼",
                    "in_success": "出庫成功",
                    "novalid_in": "無效錄入"
                },
                "unoutdetail": {
                    "tag_unout": "待出庫",
                    "scan_out": "掃碼出庫",
                    "confirm_out": "確定出庫",
                    "serial": "卷號",
                    "check_product_error": "該產品與卷芯號不符,請檢查後重新操作",
                    "stock_out_success": "出庫成功",
                    "all": "全部",
                    "all_new": "全部商戶"
                }
            }
        },
        "selectrolepopup": {
            "changerole": "切換角色",
            "createnewrole": "創建新身份",
            "searchplaceholder": "搜索角色類型或公司名稱",
            "clearsearch": "清除",
            "totalroles": "共 {count} 個可選角色",
            "noresults": "未找到匹配的角色",
            "noresultsdesc": "請嘗試其他關鍵詞，例如分銷商名稱或角色類型"
        },
        "qastepform": {
            "multi_product_incomplete": "當前有信息未填完整",
            "steporigin": {
                "stepone": "1.掃碼產品信息 -",
                "steptwo": "2.填寫車輛信息 -",
                "stepthree": "3.上傳裝貼圖片 -",
                "stepfour": "4.提交完成"
            },
            "stepone": {
                "scantop": "Step1掃碼產品信息",
                "productname": "產品名稱",
                "serialnumber": "卷號",
                "expiredate": "質保時間",
                "qacontent": "質保內容",
                "retailer": "零售商",
                "record_product": "已錄入產品",
                "delete": "刪除",
                "next": "繼續錄入",
                "submit": "結束錄入\n下一步",
                "rollnumberplaceholder": "請輸入卷號",
                "rollnumberverify": "驗證",
                "scanProductInfo": "掃碼獲取產品信息",
                "scanProductInfoError": "(若識別失敗,請手動輸入卷號驗證)",
                "popup": {
                    "tips_title": "提示",
                    "role_not_match_create_qa": "當前賬戶角色不匹配,無法創建質保",
                    "title": "確定要刪除該卷芯號嗎",
                    "confirm": "確定",
                    "cancel": "取消",
                    "retailer_confirm_title": "確認質保門店",
                    "retailer_confirm_lead": "該商品已入庫至",
                    "retailer_confirm_tail": "，請確認是否在此門店創建質保。",
                    "retailer_confirm_yes": "在此門店創建",
                    "retailer_confirm_no": "門店不對",
                    "retailer_not_match_title": "無法創建質保",
                    "retailer_not_match_lead": "該商品已入庫至",
                    "retailer_not_match_tail": "，與當前門店不一致，無法繼續創建質保。如需幫助，請聯繫該門店或客服。",
                    "retailer_not_match_confirm": "我知道了"
                },
                "toast": {
                    "select_component": "請選擇裝貼部位",
                    "no_repeat_scan": "請勿重複掃卷芯號",
                    "roll_number_noempty": "卷號不能為空",
                    "rollnumberverify_success": "驗證成功",
                    "distributor_channel_hint": "該產品屬於分銷渠道，需要由零售商創建質保，或操作入庫才可以創建質保。\n感謝理解！"
                }
            },
            "setptwo": {
                "scantop": "Step2填寫車輛信息",
                "carinfo": "車輛信息",
                "carownername": "車主姓名",
                "inputcarownername": "請輸入車主姓名",
                "next": "下一步",
                "serialnumber": "卷號",
                "toast": {
                    "answer_fill_all": "請檢查問卷是否填寫完整",
                    "carownername_fill_all": "請填寫車主姓名",
                    "phone_fill_all": "請填寫手機號",
                    "code_fill_all": "請填寫驗證碼",
                    "content_check_failed": "請輸入正確內容",
                    "singlechoice_check_failed": "請選擇數據",
                    "answer_fill_all_yes": "請檢查問卷內容是否填寫正確"
                }
            },
            "stepthree": {
                "scantop": "Step3上傳裝貼圖片",
                "ztimg": "裝貼照片",
                "serialnumber": "卷號",
                "least": "至少",
                "most": "最多",
                "unit": "張",
                "show_below_info": "下方請補充各部件裝貼照片特寫",
                "toast": {
                    "success": "創建成功",
                    "img_upload_failed": "圖片上傳數量不符"
                }
            },
            "redesign": {
                "common": {
                    "step_title": "步驟 {step} · {title}",
                    "product_progress": "產品 {current} / {total}",
                    "product_tab": "產品 {index}",
                    "prev_product": "上一個",
                    "next_product": "下一個",
                    "need_help": "需要幫助？",
                    "input_mode_aria": "錄入方式",
                    "list_separator": "、"
                },
                "stepone": {
                    "verify_success_label": "卷號驗證成功：",
                    "task_desc": "手動輸入或掃碼獲取卷號，驗證後展示產品信息與部件",
                    "manual_input": "手動輸入",
                    "scan_input": "掃碼獲取",
                    "select_warranty_parts": "選擇質保部件",
                    "parts_selected": "已選 {selected}/{total}",
                    "continue_entry_title": "繼續錄入產品",
                    "entry_title": "錄入產品",
                    "entry_status_current_total": "正在錄入第 {index} 個產品 · 共 {total} 個",
                    "entry_status_current": "正在錄入第 {index} 個產品"
                },
                "steptwo": {
                    "task_desc_single": "填寫車輛問卷與施工聯繫信息",
                    "task_desc_multi": "每個產品單獨填車輛問卷，裝貼日期與手機號多產品共用",
                    "switch_product_hint": "請使用下方按鈕切換產品，完成全部車輛問卷",
                    "mount_and_contact": "施工與聯繫",
                    "multi_product_shared": "多產品共用",
                    "shared_hint_default": "裝貼日期與車主手機號所有產品只需填寫一次",
                    "shared_hint_zhongsheng": "裝貼日期填一次即可",
                    "account_phone": "賬戶手機號",
                    "change_phone": "更換手機號",
                    "fill_owner_phone": "請填寫車主手機號",
                    "use_account_phone": "改用賬戶信息",
                    "privacy_dialog_title": "隱私提示",
                    "privacy_dialog_message": "由於【中升集團】渠道隱私建議，【車主真實姓名】及【手機號碼】建議做保密處理，是否授權填入當前賬號的名稱【{name}】及手機號碼【{phone}】？",
                    "privacy_dialog_confirm": "確認授權",
                    "privacy_dialog_manual": "手動填寫",
                    "toast_creator_info_applied": "已使用您的賬戶信息",
                    "toast_account_phone_applied": "已使用賬戶手機號",
                    "toast_no_account_phone": "賬戶未綁定手機號，請手動填寫"
                },
                "stepthree": {
                    "task_desc_single": "按質保要求上傳施工照與部件特寫",
                    "task_desc_multi": "多產品請分別上傳裝貼照片，使用下方按鈕切換",
                    "switch_product_hint": "請使用下方按鈕切換產品，完成全部裝貼照片",
                    "warranty_files_title": "質保文件",
                    "warranty_files_desc": "車輛施工與卷號相關照片",
                    "component_closeup_title": "部件特寫",
                    "component_closeup_desc": "各裝貼部件近景照片",
                    "pending_upload_hint": "產品 {products} 尚有照片待上傳"
                }
            }
        },
        "qapublicquery": {
            "hero_title": "汽車膜質保查詢",
            "hero_desc": "輸入車架號即可查詢官方質保信息",
            "logo_alt": "Castrol Auto Films",
            "search_card_title": "車架號查詢",
            "search_card_hint": "請輸入完整車架號（VIN）",
            "trust_no_login": "免登錄",
            "trust_instant": "即時查詢",
            "trust_official": "官方質保",
            "guide_phone": "手機號",
            "guide_or": "或",
            "guide_vin": "車架號",
            "guide_result": "查看結果",
            "landing_title": "開始查詢",
            "landing_desc": "輸入車架號後點擊搜索即可查看質保詳情",
            "landing_caption": "查詢後可查看完整質保信息",
            "landing_tap_hint": "點擊上方卡片開始",
            "landing_preview_code": "質保編號",
            "landing_preview_product": "產品名稱",
            "landing_preview_period": "質保有效期",
            "landing_feature_status": "質保狀態",
            "landing_feature_detail": "產品詳情",
            "landing_feature_verify": "官方核驗",
            "empty_title": "未找到質保記錄",
            "loading": "正在查詢，請稍候…",
            "result_count": "共 {count} 條質保記錄",
            "result_found": "已找到質保記錄",
            "vin_required": "請輸入車架號",
            "mock_notice": "當前為演示數據，正式接口接入後將展示真實查詢結果",
            "search_failed": "查詢失敗，請稍後重試",
            "warranty_not_found": "未找到對應質保記錄",
            "login_guide_title": "需要更多服務？",
            "login_guide_desc": "登錄後可創建質保、管理訂單，使用完整業務功能",
            "login_guide_action": "手機號查詢",
            "create_qa_action": "創建質保",
            "float_actions_expand": "展開快捷操作",
            "float_actions_collapse": "收起快捷操作"
        },
        "qasteplist": {
            "topphonesearch": "請輸入手機號查詢",
            "search": {
                "hint": "支持手機號或車架號查詢",
                "vin_hint": "支持車架號查詢",
                "phone_label": "手機號",
                "phone_placeholder": "請輸入手機號",
                "vin_label": "車架號",
                "vin_placeholder": "請輸入車架號",
                "submit": "搜索",
                "reset": "清空",
                "require_one": "請至少輸入手機號或車架號",
                "require_vin": "請輸入車架號",
                "empty_desc": "暫無匹配的質保記錄\n可調整搜索條件後重試",
                "edit": "修改"
            },
            "list_meta": "共 {count} 條記錄",
            "list_lead": "查詢到的質保記錄",
            "list_empty_lead": "暫無質保記錄",
            "tab": {
                "all": "全部",
                "unapprove": "待生效",
                "approved": "已生效",
                "rejected": "已駁回"
            },
            "item": {
                "product": "產品",
                "phone": "手機號",
                "vin": "車架號",
                "unapprove": "待生效",
                "approved": "已生效",
                "rejected": "已駁回"
            }
        },
        "qastepreview": {
            "search": "篩選",
            "tab": {
                "all": "全部",
                "unapprove": "待審核",
                "approved": "已通過",
                "rejected": "已駁回"
            },
            "item": {
                "product": "產品",
                "phone": "手機號",
                "unapprove": "待審核",
                "approved": "已通過",
                "rejected": "已駁回"
            },
            "review_success": "審核成功"
        },
        "qastepdetail": {
            "qastatus": "質保狀態",
            "carinfo": "車輛信息",
            "productname": "產品名稱",
            "serialnumber": "卷號",
            "expireddate": "質保時間",
            "qacontent": "質保內容",
            "mountparts": "裝貼部件",
            "qastarttime": "質保開始日期",
            "mountinfo": "裝貼信息",
            "mounttime": "裝貼日期",
            "retailer": "零售商",
            "zt_img": "質保圖片",
            "review": "審核",
            "carownername": "車主姓名",
            "carownerphone": "車主手機號",
            "unapprove": "待生效",
            "approved": "已生效",
            "rejected": "已駁回",
            "screenshot": {
                "save": "保存長截圖",
                "capturing": "正在生成長截圖",
                "capturing_hint": "正在整理頁面內容，請稍候",
                "capturing_slice": "正在拼接第 {current}/{total} 段",
                "capturing_saving": "正在保存圖片",
                "saved": "長截圖已保存",
                "segmented": "內容較長，已保存 {count} 張分段截圖",
                "preview_title": "長截圖預覽",
                "preview_hint": "長按圖片可保存到相冊",
                "preview_close": "關閉預覽",
                "preview_prev": "上一張",
                "preview_next": "下一張"
            },
            "qrcode": {
                "open": "分享",
                "hint": "掃碼後可查看本質保信息",
                "missing_vin": "暫無車架號，無法生成二維碼",
                "save": "保存到相冊",
                "save_hint": "長按圖片可保存到相冊",
                "saved": "二維碼已保存",
                "save_fail": "保存失敗，請重試",
                "copy_link": "複製鏈接",
                "copy_success": "鏈接已複製",
                "copy_fail": "複製失敗，請重試",
                "close": "關閉"
            },
            "ppf_warranty": {
                "detail_title": "質保範圍詳解",
                "detail_link": "詳解",
                "detail_html": "<h5>非人為因素造成的發污、龜裂、脫膠、雨斑、裝貼之前膜面表面有明顯瑕疵、黃變、水解均在質保範圍之內。</h5><h5>質保範圍詳解：</h5><ol class=\"ppf-list\"><li>發污是指膜面失去光澤，造成光禿現象；</li><li>龜裂是指膜面脆化，並發生開裂現象；</li><li>脫膠是指在裝貼且正常使用的情況下，膠層與膜層產生自動脫離現象；</li><li>雨斑是指雨水在膜面留下非常明顯且不可去除的痕跡；</li><li>裝貼之前膜面表面有明顯瑕疵是指在裝貼前，就已發現有且僅有以下情形，即白斑點、明顯異物、凝膠、明顯斜紋等；</li><li>黃變指膜面明顯發黃，輕微黃變屬於正常現象，不屬於質保範圍，即∆E＜2，不承擔售後；</li><li>水解是指膜已融化在車漆表面且無法撕除；</li><li>翹邊（從施工完交車一個月外翹邊在質保內，一月之內算施工技術問題，到店再次包邊即可）。</li></ol><h5>備註：</h5><p>因洗車液、柏油清洗劑、柏油、其它化學試劑污染過的車衣膜均不在質保範圍內。</p>",
                "detail_aria": "查看質保範圍詳解"
            }
        },
        "distributorcoupon": {
            "topsearch": {
                "content": "請輸入手機號查詢",
                "search": "搜索"
            },
            "tabs": {
                "all": "全部",
                "undo": "未核銷",
                "done": "已核銷"
            },
            "phone": "手機號",
            "scan": {
                "submit": "確認核銷",
                "scan_success": "核銷成功"
            }
        },
        "newdealershop": {
            "fullname": "商戶/公司全稱",
            "area": "地區",
            "address": "地址",
            "level": "級別",
            "createtime": "創建時間",
            "cartype": "證件類型",
            "carimg": "證件照片"
        },
        "newpurchasedetail": {
            "product_info": "產品信息",
            "purchase_id": "採購單ID",
            "purchase_date": "採購日期",
            "purchase_people": "採購人",
            "purchase_people_phone": "採購人手機號",
            "distributor_info": "分銷商信息",
            "company_name": "公司名稱",
            "people_number": "納稅人識別號",
            "address": "地址",
            "phone": "電話"
        },
        "newpurchasemanagerdetail": {
            "product_info": "產品信息",
            "purchase_id": "採購單ID",
            "purchase_date": "採購日期",
            "purchase_company": "採購商",
            "purchase_people": "採購人",
            "purchase_people_phone": "採購人手機號"
        },
        "shoporder": {
            "orderlist": "交易列表",
            "goorder": "購買",
            "style": "型號",
            "no_sku_price_tips": "暫無價格",
            "current_sku_no_price_tips": "當前sku無法下單",
            "first_select_address": "請先選擇地址",
            "create_payment_success": "創建成功",
            "go_to_payment": "是否要現在付款?\n若當前未付款,可在訂單詳情中繼續付款",
            "payment_create_confirm": "創建",
            "payment_create_back": "返回",
            "please_retry_select_goods": "當前選擇商品暫無價格,請重新選擇",
            "all_price": "合計",
            "search": {
                "search_input_order_placeholder": "請輸入訂單ID查詢",
                "search_input_payment_placeholder": "請輸入付款單ID查詢"
            },
            "orderitem": {
                "orderid": "訂單ID",
                "channelinfo": "渠道資訊",
                "orderdate": "下單日期",
                "orderperson": "下單人",
                "orderphone": "下單人手機號",
                "buyerpartytype": "下單主體類型",
                "buyerpartyname": "下單主體",
                "buy_from": "購買商",
                "paymentorderid": "付款單ID",
                "paymentorderbuyertype": "付款主體類型",
                "paymentorderbuyername": "付款主體",
                "createorderdate": "創建日期",
                "paymentorderdate": "付款日期",
                "confirmorderdate": "確認日期",
                "paymentorderinfo": "付款單信息",
                "orderamount": "訂單金額",
                "orderaddress": "地址",
                "changestatus": "修改狀態",
                "statusscuess": "狀態更新成功",
                "change_status_confirming": "待確認",
                "change_status_confirmed": "確認",
                "change_status_closed": "關閉",
                "payment_method": "付款方式",
                "payment_time": "付款時間",
                "payment_time_now": "當前時間",
                "payment_time_manual": "手動調整",
                "id": "ID"
            },
            "orderdetail": {
                "gobuy": "創建付款單",
                "viewgodetail": "查看發貨詳情",
                "gosend": "去發貨",
                "sku_amount": "SKU金額",
                "distribution_costs": "配送費用",
                "sku_reduce": "SKU立減",
                "discount_amount": "折扣金額",
                "really_pay": "實付款",
                "channel_title": "渠道資訊",
                "channel_id": "渠道ID",
                "channel_name": "渠道名稱",
                "channel_type": "渠道類型",
                "buyer_title": "買方信息",
                "buyer_title_order": "下單信息",
                "store_title": "店鋪信息",
                "order_info": "訂單信息",
                "store_id": "店鋪ID",
                "store_name": "店鋪名稱",
                "pricedetail": "價格明細",
                "paymentmethod": "支付方式",
                "orderpayment": "付款單明細",
                "watch_bank_info": "查看銀行卡信息",
                "up_bank_info": "收起",
                "createorder": "創建訂單",
                "padding_pay_amount": "待付款金額",
                "padding_confirming_amount": "待確認金額",
                "confirmed_amount": "已確認金額",
                "paymentamount": "需支付金額",
                "createpaytime": "創建時間",
                "buyerpartid": "買方ID",
                "buyertype": "買方類型",
                "buyerstyle": "買方類型",
                "buyerpartname": "買方名稱",
                "buyerpeople": "下單人",
                "buyerphonenumber": "下單人手機號",
                "buyerpeople_new": "付款人",
                "buyerphonenumber_new": "付款人電話",
                "order_id": "訂單ID",
                "order_time": "下單時間",
                "order_status": "訂單狀態",
                "formatted": "格式化",
                "added": "添加",
                "select_full_date": "選擇完整時間",
                "full_date_year": "年",
                "full_date_month": "月",
                "full_date_day": "日",
                "full_date_hour": "時",
                "full_date_minute": "分",
                "full_date_second": "秒",
                "confirm": "確定",
                "cancel": "取消",
                "alipay_redirecting": "正在喚起支付寶支付，請稍候…",
                "alipay_querying": "正在查詢支付結果，請稍候…",
                "alipay_success": "支付成功",
                "alipay_back": "返回",
                "alipay_scan_tip": "請使用支付寶掃碼支付",
                "alipay_scan_sub": "支付完成後將自動檢測",
                "buyer_title_order_new": "付款人信息",
                "order_info_new": "訂單信息",
                "buyer_title_new_title": "付款方信息",
                "buyerpartid_new": "付款方ID",
                "buyerstyle_new": "付款方類型",
                "buyerpartname_new": "付款方名稱",
                "transactionNo_detail": "交易流水號",
                "enter_transactionNo": "請輸入交易流水號",
                "confirm_date": "確認時間",
                "payment_date": "付款時間"
            },
            "ordermanager": {
                "tab": {
                    "all": "全部",
                    "unpay": "待付款",
                    "unconfirmed": "待確認",
                    "partpay": "部分確認",
                    "payed": "已確認",
                    "closed": "已關閉"
                }
            },
            "stockout": {
                "totalQty": "總數量",
                "pendingOutboundQty": "待出庫數量",
                "pendingInboundQty": "待入庫數量",
                "inboundQty": "已入庫數量",
                "outboundtime": "出庫時間",
                "outboundoperation": "出庫說明",
                "outboundoperation_placeholder": "請輸入出庫說明"
            },
            "store": {
                "storeid": "ID",
                "storename": "名稱"
            }
        },
        "service": {
            "servicecenter": {
                "search_input_servicecenter_placeholder": "請輸入服務網點名稱查詢",
                "create": "創建服務網點",
                "creation": {
                    "name": "服務網點名稱",
                    "workcount": "工位數量",
                    "confirm": "確定",
                    "confirmcreate": "確定創建",
                    "create_success_tips": "服務網點創建成功"
                },
                "detail": {
                    "name": "服務網點名稱",
                    "address": "地區",
                    "fulladdress": "地址",
                    "contractphone": "聯繫電話",
                    "workcount": "工位數量"
                }
            },
            "manager": {
                "search": {
                    "content": "請輸入服務名稱"
                },
                "tab": {
                    "all": "全部",
                    "not_scheduled": "未預約",
                    "scheduled": "已預約",
                    "served": "已服務",
                    "not_required": "無需服務"
                },
                "detail": {
                    "amount_all": "共計"
                }
            }
        },
        "address": {
            "list": {
                "search_input_address_placeholder": "請輸入地址查詢",
                "create": "新增地址"
            },
            "create": {
                "owneraddress": "所在地區",
                "fulladdress": "詳細地址與門牌號",
                "name": "收貨人名字",
                "saveaddress": "保存地址",
                "successtips": "地址創建成功"
            },
            "detail": {
                "country": "國家/地區",
                "fulladdress": "詳細地址",
                "recipientName": "收貨人姓名",
                "phone": "手機號"
            }
        },
        "warehouse": {
            "list": {
                "search_input_address_placeholder": "請輸入倉庫名稱查詢",
                "create": "新增倉庫"
            },
            "create": {
                "owneraddress": "所在地區",
                "fulladdress": "詳細地址與門牌號",
                "name": "倉庫全稱",
                "savewarehouse": "保存倉庫",
                "successtips": "倉庫創建成功"
            },
            "detail": {
                "first_select_warehouse": "請先選擇倉庫",
                "verify": "校驗",
                "confirm": "確定"
            }
        },
        "storemanager": {
            "detail": {
                "fullname": "店鋪名稱",
                "salesStatus": "售賣狀態",
                "shoplogo": "店鋪logo"
            }
        },
        "charts": {
            "qachart": {
                "name": "質保報表"
            },
            "purchasechart": {
                "name": "採購報表"
            },
            "inoutstockchart": {
                "name": "出入庫報表"
            }
        },
        "apptheme": {
            "themesystem": "背景方案切換"
        },
        "errorinfopopup": {
            "title": "異常信息",
            "detail": "詳情",
            "close": "關閉"
        },
        "logout": {
            "title": "確定要退出登錄嗎",
            "confirm": "確定",
            "cancel": "取消"
        },
        "docker": {
            "website": "首頁",
            "main": "地圖",
            "scheme": "方案",
            "mine": "我的"
        }
    }
};
